import { z } from 'zod';

const LogoPreferencesCodeZod = z.union([z.literal('myadvocate_logo'), z.literal('advisor_logo'), z.literal('no_logo')]);

export const AdvisorPropertiesZod = z.object({
    logoPreferencesCode: z
        .object({
            diagrams: LogoPreferencesCodeZod.optional(),
            documents: LogoPreferencesCodeZod.optional(),
        })
        .optional(),
    showQr: z.boolean().optional(),
    showDisclaimer: z.boolean().optional(),
});
export type AdvisorProperties = z.infer<typeof AdvisorPropertiesZod>;
